"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORK_ORDER_BID_REQUEST_STATUS = void 0;
exports.WORK_ORDER_BID_REQUEST_STATUS = {
    OPEN: 'Open',
    IN_PROGRESS: 'In Progress',
    CANCELLED: 'Cancelled',
    COMPLETE: 'Complete',
    DELETED: 'Deleted',
};
//# sourceMappingURL=work-order-bid-request.types.js.map